// extracted by mini-css-extract-plugin
export default {"avatar":"Request_avatar__gYJ0y","cell":"Request_cell__Ckm7d","flex":"Request_flex__vim3o","block":"Request_block__U9zhe"};